var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-frame"},_vm._l((_vm.sortedBadgeFrameItems),function(item,index){return _c('ReadinessBadge',{key:item.id,attrs:{"level":item.proficiencylevel,"dot":item.dot,"avatar":item.avatar,"firstName":item.firstName,"lastName":item.lastName,"id":item.id},on:{"removeHolder":function($event){return _vm.removeHolder(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }